"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticIA = void 0;
const Article_1 = require("../Article");
const echain_product_models_1 = require("@igus/echain-product-models");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
class StaticIA extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'StaticIA';
    }
    get arty() {
        return this.model.Arty;
    }
    set arty(value) {
        this.model.Arty = value;
    }
    get artyConnect() {
        return this.model.ArtyConnect;
    }
    set artyConnect(value) {
        this.model.ArtyConnect = value;
    }
    get fugrTyp() {
        return this.model.FUGRTyp;
    }
    set fugrTyp(value) {
        this.model.FUGRTyp = value;
    }
    get iaFugrTyp() {
        return this.model.IAFugrTyp;
    }
    set iaFugrTyp(value) {
        this.model.IAFugrTyp = value;
    }
    get typ() {
        return this.model.Typ;
    }
    set typ(value) {
        this.model.Typ = value;
    }
    get iaBodenH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IABodenH);
    }
    set iaBodenH(value) {
        this.model.IABodenH = value.quantity;
    }
    get iaHKB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKB);
    }
    set iaHKB(value) {
        this.model.IAHKB = value.quantity;
    }
    get iaHKBOT() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKBOT);
    }
    set iaHKBOT(value) {
        this.model.IAHKBOT = value.quantity;
    }
    get iaHKDist() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKDist);
    }
    set iaHKDist(value) {
        this.model.IAHKDist = value.quantity;
    }
    get iaHKH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKH);
    }
    set iaHKH(value) {
        this.model.IAHKH = value.quantity;
    }
    get iaHKHeight() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKHeight);
    }
    set iaHKHeight(value) {
        this.model.IAHKHeight = value.quantity;
    }
    get iaHKOLB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOLB);
    }
    set iaHKOLB(value) {
        this.model.IAHKOLB = value.quantity;
    }
    get iaHKOLOB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOLOB);
    }
    set iaHKOLOB(value) {
        this.model.IAHKOLOB = value.quantity;
    }
    get iaHKOLOH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOLOH);
    }
    set iaHKOLOH(value) {
        this.model.IAHKOLOH = value.quantity;
    }
    get iaHKOLUB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOLUB);
    }
    set iaHKOLUB(value) {
        this.model.IAHKOLUB = value.quantity;
    }
    get iaHKOLUH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOLUH);
    }
    set iaHKOLUH(value) {
        this.model.IAHKOLUH = value.quantity;
    }
    get iaHKOLUHRounded() {
        return this.model.IAHKOLUH_Rounded;
    }
    set iaHKOLUHRounded(value) {
        this.model.IAHKOLUH_Rounded = value;
    }
    get iaHKORB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKORB);
    }
    set iaHKORB(value) {
        this.model.IAHKORB = value.quantity;
    }
    get iaHKOROB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKOROB);
    }
    set iaHKOROB(value) {
        this.model.IAHKOROB = value.quantity;
    }
    get iaHKORUB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKORUB);
    }
    set iaHKORUB(value) {
        this.model.IAHKORUB = value.quantity;
    }
    get iaHKRep() {
        return this.model.IAHKRep;
    }
    set iaHKRep(value) {
        this.model.IAHKRep = value;
    }
    get iaHKULB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKULB);
    }
    set iaHKULB(value) {
        this.model.IAHKULB = value.quantity;
    }
    get iaHKULOB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKULOB);
    }
    set iaHKULOB(value) {
        this.model.IAHKULOB = value.quantity;
    }
    get iaHKULOH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKULOH);
    }
    set iaHKULOH(value) {
        this.model.IAHKULOH = value.quantity;
    }
    get iaHKULOHRounded() {
        return this.model.IAHKULOH_Rounded;
    }
    set iaHKULOHRounded(value) {
        this.model.IAHKULOH_Rounded = value;
    }
    get iaHKULUB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKULUB);
    }
    set iaHKULUB(value) {
        this.model.IAHKULUB = value.quantity;
    }
    get iaHKULUH() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKULUH);
    }
    set iaHKULUH(value) {
        this.model.IAHKULUH = value.quantity;
    }
    get iaHKURB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKURB);
    }
    set iaHKURB(value) {
        this.model.IAHKURB = value.quantity;
    }
    get iaHKUROB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKUROB);
    }
    set iaHKUROB(value) {
        this.model.IAHKUROB = value.quantity;
    }
    get iaHKURUB() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAHKURUB);
    }
    set iaHKURUB(value) {
        this.model.IAHKURUB = value.quantity;
    }
    get iaKisteHO() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAKisteHO);
    }
    set iaKisteHO(value) {
        this.model.IAKisteHO = value.quantity;
    }
    get iaKisteHU() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAKisteHU);
    }
    set iaKisteHU(value) {
        this.model.IAKisteHU = value.quantity;
    }
    get iaUebermass() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAUebermass);
    }
    set iaUebermass(value) {
        this.model.IAUebermass = value.quantity;
    }
    get iaWmm() {
        return (0, echain_shared_quantities_1.Q)(this.model.IAwmm);
    }
    set iaWmm(value) {
        this.model.IAwmm = value.quantity;
    }
    get xPos() {
        return echain_shared_quantities_1.Q.optional(this.model.XPos);
    }
    set xPos(value) {
        this.model.XPos = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get yPos() {
        return echain_shared_quantities_1.Q.optional(this.model.YPos);
    }
    set yPos(value) {
        this.model.YPos = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get zPos() {
        return echain_shared_quantities_1.Q.optional(this.model.ZPos);
    }
    set zPos(value) {
        this.model.ZPos = value === null || value === void 0 ? void 0 : value.quantity;
    }
    static fromJson(args) {
        const staticIa = new StaticIA({
            ArticleType: echain_product_models_1.ArticleType.ia,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
            IABodenH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKBOT: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKDist: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKHeight: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLOB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLOH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLUB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLUH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOLUH_Rounded: false,
            IAHKORB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKOROB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKORUB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKRep: 0,
            IAHKULB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKULOB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKULOH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKULOH_Rounded: false,
            IAHKULUB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKULUH: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKURB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKUROB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAHKURUB: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAKisteHO: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAKisteHU: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAUebermass: echain_shared_quantities_1.Q.Length.mm(0).quantity,
            IAwmm: echain_shared_quantities_1.Q.Length.mm(0).quantity,
        });
        staticIa.fromJson(args);
        return staticIa;
    }
    isIntersectAllowed(ia) {
        return false;
    }
    isConnectAllowed(ia) {
        let isArtNrConnect = false;
        if (this.artyConnect) {
            const articleTypes = this.artyConnect.split('|');
            articleTypes.forEach((articleType) => {
                isArtNrConnect = isArtNrConnect || ia.artikeltyp === parseInt(articleType.trim(), 10);
            });
        }
        return isArtNrConnect;
    }
    clone() {
        return StaticIA.fromJson(this.toJson());
    }
    duplicate() {
        const json = this.toJson();
        delete json.EntityId;
        return StaticIA.fromJson(json);
    }
}
exports.StaticIA = StaticIA;
//# sourceMappingURL=StaticIA.js.map